import { render, staticRenderFns } from "./ModalMarketplaceList.vue?vue&type=template&id=63469650&"
import script from "./ModalMarketplaceList.vue?vue&type=script&lang=js&"
export * from "./ModalMarketplaceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports